import { HealthSystemDetailsData } from './types'
import { MY_COMMUNITY_KEYS } from '../../constants'

export const initialHealthSystemDetails: HealthSystemDetailsData = {
  uuid: '',
  name: '',
  legal_name: '',
  website: '',
  email: '',
  status: '',
  vice_president: {
    uuid: '',
    first_name: '',
    last_name: '',
    role: '',
    status: '',
    email: '',
    timezone: {
      uuid: '',
      name: '',
      offset: ''
    }
  },
  address: {
    state: '',
    street: '',
    zip_code: '',
    city: ''
  },
  departments: [],
  national_gpo: null,
  admin_fees: []
}

export const BREADCRUMBS = (title: string) => [
  {
    children: 'My Community',
    href: '/my-community',
    state: { redirectTab: MY_COMMUNITY_KEYS.communities }
  },
  {
    children: title
  }
]

export const HEALTH_SYSTEM_DETAILS_TABS = [
  {
    key: 'general',
    label: 'Health system Details'
  },
  {
    key: 'users',
    label: 'Users'
  }
]

export const HEALTH_SYSTEM_DETAILS_TABS_KEYS = {
  general: 'general',
  users: 'users'
}
